export default {
  generalSettings: 'Configurações Gerais',
  changeDisplayLanguage: 'Idioma de Exibição',
  changeDisplayLanguageInfo: 'Escolha o idioma padrão de sua preferência',
  nav: {
      audits: 'Auditorias',
      vulnerabilities: 'Vulnerabilidades',
      data: 'Dados',
  },
  btn: {
      cancel: 'Cancelar',
      confirm: 'Confirmar',
      create: 'Criar',
      ok: 'ok',
      leave: 'Sair',
      stay: 'Permanecer',
      generateAnyway: 'Gerar mesmo assim',
      topButtonSection: {
          submitReview: 'Enviar Revisão',
          cancelReview: 'Cancelar Revisão',
          approve: 'Aprovar',
          removeApproval: 'Remover Aprovação',
          createRetest: 'Criar Reteste',
          navigateRetest: 'Acessar Reteste'
      },
      backupFinding: 'Propor Criação / Atualização no Banco de Dados de Vulnerabilidades',
      delete: 'Excluir',
      save: 'Salvar',
      saved: 'Salvo',
      update: 'Atualizar',
      deleteAll: 'Excluir Tudo',
      close: 'Close',
      enable: 'Habilitar',
      valid: 'Válido',
      new: 'Novo',
      updates: 'Atualizações',
      updatesAvailable: 'Atualizações disponíveis',
      dismissAllUpdates: 'Descartar todas as propostas em {language}',
      dismissProposal: 'Descartar proposta',
      dismissEveryUpdate: 'Descartar todas as propostas',
      accountsEnabled: 'Contas Habilitadas',
      accountsDisabled: 'Contas Desabilitadas',
      accountEnabled: 'Conta Habilitada',
      accountDisabled: 'Conta Desabilitada',
      disable: 'Desabilitar',
      qa: 'QA',
      comments: 'Comentários',
      discard: 'Descartar',
  },
  tooltip: {
    vulnerabilityUpdates: 'Revisar as propostas de atualização desta vulnerabilidade',
    usersConnected: 'Usuários na Auditoria:',
    editAudit: 'Editar Auditoria',
    downloadReport: 'Baixar Relatório',
    downloadReportWithUnsavedDrafts: 'Existem alterações locais recuperadas e elas não serão incluídas no relatório até serem salvas',
    auditDraftUnsavedChanges: 'Existem alterações locais recuperadas',
    deleteAudit: 'Excluir Auditoria',
    removeAudit: 'Remover Auditoria (A auditoria não será excluída)',
    topButtonSection: {
        submitReview: 'Marcar auditoria como pronta para revisão',
        cancelReview: 'Fazer alterações na auditoria',
        approve: 'Aprovar esta auditoria',
        removeApproval: 'Remover aprovação da auditoria',
        createRetest: 'Criar um Reteste para esta Auditoria',
        navigateRetest: 'Acessar o Reteste desta Auditoria'
    },
    sortOptions: 'Opções de Ordenação',
    addToFindings: 'Adicionar às Descobertas',
    edit: 'Editar',
    view: 'Visualizar',
    findAudits: 'Encontrar Auditorias',
    delete: 'Excluir',
    download: 'Baixar',
    retestSplitView: 'Ativar visualização dividida com dados originais de Descobertas',
    addAudit: 'Adicionar Auditoria',
    auditQa: 'Mostrar painel de QA',
    vulnerabilityQa: 'Mostrar painel de QA'
},
msg: {
    auditReviewUpdateOk: 'Status da revisão da auditoria atualizado com sucesso',
    auditApprovalUpdateOk: 'Aprovação da auditoria atualizada com sucesso',
    auditUpdateOk: 'Auditoria atualizada com sucesso',
    findingCreateOk: 'Descoberta criada com sucesso',
    findingUpdateOk: 'Descoberta atualizada com sucesso',
    findingDeleteOk: 'Descoberta excluída com sucesso',
    doYouWantToLeave: 'Você realmente deseja sair?',
    thereAreUnsavedChanges: 'Existem alterações não salvas!',
    auditDraftDownloadWarningTitle: 'Existem alterações locais recuperadas',
    auditDraftDownloadWarningMessage: 'Esta auditoria possui alterações locais recuperadas que não foram salvas no servidor. Elas não serão incluídas no relatório gerado a menos que você as salve primeiro.',
    fieldRequired: 'Por favor, preencha todos os campos obrigatórios',
    deleteFindingConfirm: 'Excluir Descoberta atual?',
    deleteFindingNotice: 'Esta ação não pode ser desfeita',
    selectHost: 'Selecionar Hospedeiro',
    importHostsFirst: 'Importar Hospedeiros primeiro',
    auditTypeNotSet: 'Tipo de Auditoria não definido',
    sectionUpdateOk: 'Seção atualizada com sucesso',
    lastnameRequired: 'Sobrenome obrigatório',
    firstnameRequired: 'Nome obrigatório',
    emailRequired: 'Email obrigatório',
    clientCreatedOk: 'Cliente criado com sucesso',
    clientUpdatedOk: 'Cliente atualizado com sucesso',
    clientDeletedOk: 'Cliente excluído com sucesso',
    deleteNotice: 'será excluído permanentemente',
    confirmSuppression: 'Confirmar Supressão',
    confirmRemoval: 'Confirmar Remoção',
    usernameRequired: 'Nome de usuário obrigatório',
    passwordRequired: 'Senha obrigatória',
    currentPasswordRequired: 'Senha atual obrigatória',
    confirmPasswordDifferents: 'Nova Senha e Confirmação de Senha são diferentes',
    passwordComplexity: 'A senha deve ter pelo menos 8 caracteres com no mínimo 1 maiúscula, 1 minúscula e 1 número',
    collaboratorCreatedOk: 'Colaborador criado com sucesso',
    collaboratorUpdatedOk: 'Colaborador atualizado com sucesso',
        roleCreatedOk: 'Role created successfully',
    roleUpdatedOk: 'Role updated successfully',
    roleDeletedOk: 'Role deleted successfully',
    roleDisplayNameRequired: 'Role display name required',
    roleNameRequired: 'Role name required',
    usersUpdatedOk: 'Users updated successfully',
    nameRequired: 'Nome obrigatório',
    fileRequired: 'Arquivo obrigatório',
    companyCreatedOk: 'Empresa criada com sucesso',
    companyUpdatedOk: 'Empresa atualizada com sucesso',
    companyDeletedOk: 'Empresa excluída com sucesso',
    templateNotFound: 'Modelo Não Encontrado',
    templateCreatedOk: 'Modelo criado com sucesso',
    templateUpdatedOk: 'Modelo atualizado com sucesso',
    allVulnerabilitesDeleteNotice: 'Todas as Vulnerabilidades serão excluídas permanentemente',
    allVulnerabilitesDeleteOk: 'Todas as vulnerabilidades excluídas com sucesso',
    profileUpdateOk: 'Perfil atualizado com sucesso',
    settingsUpdatedOk: 'Configurações atualizadas com sucesso',
    revertingSettings: 'Revertendo configurações!',
    revertingSettingsConfirm: 'Você realmente deseja reverter as configurações para os padrões? Você perderá todas as configurações atuais.',
    importingSettings: 'Importando configurações!',
    importingSettingsConfirm: 'Você realmente deseja importar as novas configurações? Você perderá todas as configurações atuais que forem substituídas.',
    settingsImportedOk: 'Configurações importadas com sucesso',
    vulnerabilityCreatedOk: 'Vulnerabilidade criada com sucesso',
    vulnerabilityUpdatedOk: 'Vulnerabilidade atualizada com sucesso',
    vulnerabilityDeletedOk: 'Vulnerabilidade excluída com sucesso',
    vulnerabilityWillBeDeleted: 'Vulnerabilidade será excluída permanentemente',
    updatesDismissedOk: 'Propostas de atualização descartadas com sucesso',
    confirmDismissUpdates: 'Confirmar descarte',
    updatesWillBeDismissed: 'Todas as propostas em {language} serão excluídas permanentemente',
    updateWillBeDismissed: 'A proposta de {creator} será excluída permanentemente',
    everyUpdateWillBeDismissed: 'Todas as propostas desta vulnerabilidade serão excluídas permanentemente, em todos os idiomas',
    confirmCategoryChange: 'Confirmar mudança de Categoria',
    categoryChangingNotice: 'A exibição de Campos Personalizados pode ser afetada ao mudar a Categoria',
    vulnerabilityMergeOk: 'Vulnerabilidade mesclada com sucesso',
    tryingToContactBackend: '<p>Tentando entrar em contato com o servidor</p>',
    wrongContactingBackend: 'Algo deu errado ao entrar em contato com o servidor',
    highlightWarningTitle: 'Texto destacado ainda presente!',
    noAuditTypeForThisStage: 'Nenhum tipo de auditoria para esta etapa. Crie um tipo de auditoria primeiro'
},
err: {
  notDefinedLanguage: 'Não definido para este idioma',
  invalidYamlFormat: 'Formato YAML inválido detectado',
  parsingError1: 'Erro de análise: {0}',
  parsingError2: 'Erro de análise: linha {0}, coluna: {1}',
  invalidJsonFormat: 'Formato JSON inválido detectado',
  jsonMustBeAnObject: 'JSON deve ser um objeto.',
  importingSettingsError: 'Erro ao importar configurações',
  errorWhileParsingJsonContent: 'Erro ao analisar conteúdo JSON: {0}',
  titleRequired: 'Título obrigatório',
  expiredToken: 'Token expirado',
  invalidToken: 'Token inválido',
  invalidCredentials: 'Credenciais inválidas',
},
cvss: {
  title: 'Pontuação Base CVSS v3.1',
  impactSubscore: 'Subpontuação de Impacto',
  exploitabilitySubscore: 'Subpontuação de Explorabilidade',
  infoWhenNoScore: 'Selecione valores para todas as métricas base para gerar a pontuação',
  attackVector: 'Vetor de Ataque',
  attackComplexity: 'Complexidade do Ataque',
  privilegesRequired: 'Privilégios Necessários',
  userInteraction: 'Interação do Usuário',
  scope: 'Escopo',
  confidentialityImpact: 'Impacto de Confidencialidade',
  integrityImpact: 'Impacto de Integridade',
  availabilityImpact: 'Impacto de Disponibilidade',
  network: 'Rede',
  adjacentNetwork: 'Rede Adjacente',
  local: 'Local',
  physical: 'Físico',
  low: 'Baixo',
  high: 'Alto',
  none: 'Nenhum',
  required: 'Obrigatório',
  unchanged: 'Inalterado',
  changed: 'Alterado',
  temporalEnvironmentalTitle: 'Pontuações Temporais e Ambientais',
  temporalTitle: 'Pontuação Temporal',
  environmentalTitle: 'Pontuação Ambiental',
  environmentalModifiedImpact: 'Subpontuação de Impacto Modificado',
  environmentalModifiedExploitability: 'Subpontuação de Explorabilidade Modificada',
  exploitCodeMaturity: 'Maturidade do Código de Exploração',
  remediationLevel: 'Nível de Remediação',
  reportConfidence: 'Confiança no Relatório',
  confidentialityRequirement: 'Requisito de Confidencialidade',
  integrityRequirement: 'Requisito de Integridade',
  availabilityRequirement: 'Requisito de Disponibilidade',
  modifiedAttackVector: 'Vetor de Ataque Modificado',
  modifiedAttackComplexity: 'Complexidade de Ataque Modificada',
  modifiedPrivilegesRequired: 'Privilégios Necessários Modificados',
  modifiedUserInteraction: 'Interação do Usuário Modificada',
  modifiedScope: 'Escopo Modificado',
  modifiedConfidentialityImpact: 'Impacto de Confidencialidade Modificado',
  modifiedIntegrityImpact: 'Impacto de Integridade Modificado',
  modifiedAvailabilityImpact: 'Impacto de Disponibilidade Modificado',
  notDefined: 'Não Definido',
  unproven: 'Não Comprovado',
  poc: 'Prova de Conceito',
  functional: 'Funcional',
  officialFix: 'Correção Oficial',
  temporaryFix: 'Correção Temporária',
  workaround: 'Solução Alternativa',
  unavailable: 'Indisponível',
  unknown: 'Desconhecido',
  reasonable: 'Razoável',
  confirmed: 'Confirmado',
  medium: 'Médio',
  tooltip: {
    baseMetricGroup_Legend: "O grupo de Métricas Base representa as características intrínsecas de uma vulnerabilidade que são constantes ao longo do tempo e em diferentes ambientes de usuário. Determine o componente vulnerável e pontue o Vetor de Ataque, Complexidade do Ataque, Privilégios Necessários e Interação do Usuário em relação a isso.",
    AV_Heading: "Essa métrica reflete o contexto pelo qual a exploração da vulnerabilidade é possível. A Pontuação Base aumenta quanto mais remoto (logicamente e fisicamente) um atacante pode estar para explorar o componente vulnerável.",
    AV_N_Label: "O componente vulnerável está vinculado à pilha de rede e o conjunto de possíveis atacantes se estende além das outras opções listadas, até e incluindo a Internet inteira. Tal vulnerabilidade é frequentemente denominada 'explorável remotamente' e pode ser entendida como um ataque que pode ser explorado no nível de protocolo a uma ou mais etapas de rede de distância (por exemplo, através de um ou mais roteadores).",
    AV_A_Label: "O componente vulnerável está vinculado à pilha de rede, mas o ataque é limitado no nível de protocolo a uma topologia logicamente adjacente. Isso pode significar que um ataque deve ser lançado a partir da mesma rede física compartilhada (por exemplo, Bluetooth ou IEEE 802.11) ou lógica (por exemplo, sub-rede IP local), ou de dentro de um domínio administrativo seguro ou limitado de outra forma (por exemplo, MPLS, VPN segura para uma zona de rede administrativa).",
    AV_L_Label: "O componente vulnerável não está vinculado à pilha de rede e o caminho do atacante é via capacidades de leitura/escrita/execução. Ou seja, o atacante explora a vulnerabilidade acessando o sistema de destino localmente (por exemplo, teclado, console) ou remotamente (por exemplo, SSH); ou o atacante depende da Interação do Usuário por outra pessoa para executar ações necessárias para explorar a vulnerabilidade (por exemplo, enganar um usuário legítimo para abrir um documento malicioso).",
    AV_P_Label: "O ataque exige que o atacante toque ou manipule fisicamente o componente vulnerável. A interação física pode ser breve ou persistente.",
    AC_Heading: "Essa métrica descreve as condições além do controle do atacante que devem existir para explorar a vulnerabilidade. Tais condições podem exigir a coleta de mais informações sobre o alvo ou exceções computacionais. A avaliação dessa métrica exclui quaisquer requisitos de interação do usuário para explorar a vulnerabilidade. Se uma configuração específica for necessária para que um ataque tenha sucesso, as métricas Base devem ser pontuadas considerando que o componente vulnerável está nessa configuração.",
    AC_L_Label: "Não existem condições de acesso especializadas ou circunstâncias atenuantes. Um atacante pode esperar sucesso repetível contra o componente vulnerável.",
    AC_H_Label: "Um ataque bem-sucedido depende de condições além do controle do atacante. Ou seja, um ataque bem-sucedido não pode ser realizado a qualquer momento, mas requer que o atacante invista alguma quantidade mensurável de esforço na preparação ou execução contra o componente vulnerável antes que um ataque bem-sucedido possa ser esperado. Por exemplo, um ataque bem-sucedido pode exigir que um atacante: obtenha conhecimento sobre o ambiente em que o alvo/componente vulnerável existe; prepare o ambiente de destino para melhorar a confiabilidade da exploração; ou se injete no caminho de rede lógica entre o alvo e o recurso solicitado pela vítima para ler e/ou modificar as comunicações de rede (por exemplo, um ataque de \"man-in-the-middle\").",
    PR_Heading: "Essa métrica descreve o nível de privilégios que um atacante deve possuir antes de explorar com sucesso a vulnerabilidade.",
    PR_N_Label: "O atacante não está autorizado antes do ataque e, portanto, não requer nenhum acesso a configurações ou arquivos para executar um ataque.",
    PR_L_Label: "O atacante está autorizado com (ou seja, requer) privilégios que fornecem capacidades básicas de usuário que normalmente poderiam afetar apenas configurações e arquivos de propriedade de um usuário. Alternativamente, um atacante com privilégios baixos pode ter a capacidade de causar um impacto apenas em recursos não sensíveis.",
    PR_H_Label: "O atacante está autorizado com (ou seja, requer) privilégios que fornecem controle significativo (por exemplo, administrativo) sobre o componente vulnerável, o que poderia afetar configurações e arquivos em todo o componente.",
    UI_Heading: "Essa métrica captura o requisito de um usuário, que não seja o atacante, de participar na comprometimento bem-sucedido do componente vulnerável. Essa métrica determina se a vulnerabilidade pode ser explorada apenas à vontade do atacante, ou se um usuário separado (ou um processo iniciado pelo usuário) deve participar de alguma maneira.",
    UI_N_Label: "O sistema vulnerável pode ser explorado sem nenhuma interação de qualquer usuário.",
    UI_R_Label: "A exploração bem-sucedida dessa vulnerabilidade requer que um usuário tome alguma ação antes que a vulnerabilidade possa ser explorada.",
    S_Heading: "Um ataque bem-sucedido afeta um componente além do componente vulnerável? Se sim, a Pontuação Base aumenta e as métricas de Confidencialidade, Integridade e Autenticação devem ser pontuadas em relação ao componente afetado.",
    S_U_Label: "Uma vulnerabilidade explorada pode afetar apenas recursos gerenciados pela mesma autoridade de segurança. Nesse caso, o componente vulnerável e o componente afetado são iguais ou ambos são gerenciados pela mesma autoridade de segurança.",
    S_C_Label: "Uma vulnerabilidade explorada pode afetar recursos além do escopo de segurança gerenciado pela autoridade de segurança do componente vulnerável. Nesse caso, o componente vulnerável e o componente afetado são diferentes e gerenciados por autoridades de segurança diferentes.",
    C_Heading: "Essa métrica mede o impacto na confidencialidade dos recursos de informações gerenciados por um componente de software devido a uma vulnerabilidade explorada com sucesso. A confidencialidade refere-se a limitar o acesso e a divulgação de informações apenas a usuários autorizados, bem como a impedir o acesso ou a divulgação a usuários não autorizados.",
    C_N_Label: "Não há perda de confidencialidade no componente afetado.",
    C_L_Label: "Existe alguma perda de confidencialidade. O acesso a algumas informações restritas é obtido, mas o atacante não tem controle sobre quais informações são obtidas, ou a quantidade ou tipo de perda é limitada. A divulgação de informações não causa uma perda direta e séria no componente afetado.",
    C_H_Label: "Existe uma perda total de confidencialidade, resultando na divulgação de todos os recursos no componente afetado para o atacante. Alternativamente, o acesso a apenas algumas informações restritas é obtido, mas as informações divulgadas apresentam um impacto direto e sério.",
    I_Heading: "Essa métrica mede o impacto na integridade de uma vulnerabilidade explorada com sucesso. Integridade refere-se à confiabilidade e veracidade das informações.",
    I_N_Label: "Não há perda de integridade no componente afetado.",
    I_L_Label: "A modificação dos dados é possível, mas o atacante não tem controle sobre a consequência de uma modificação, ou a quantidade de modificação é limitada. A modificação dos dados não tem um impacto direto e sério no componente afetado.",
    I_H_Label: "Existe uma perda total de integridade ou uma perda completa de proteção. Por exemplo, o atacante é capaz de modificar qualquer/arquivos protegidos pelo componente afetado. Alternativamente, apenas alguns arquivos podem ser modificados, mas a modificação maliciosa apresentaria uma consequência direta e séria ao componente afetado.",
    A_Heading: "Essa métrica mede o impacto na disponibilidade do componente afetado decorrente de uma vulnerabilidade explorada com sucesso. Refere-se à perda de disponibilidade do próprio componente afetado, como um serviço em rede (por exemplo, web, banco de dados, e-mail). Uma vez que a disponibilidade se refere à acessibilidade de recursos de informações, ataques que consomem largura de banda de rede, ciclos de processador ou espaço em disco impactam a disponibilidade de um componente afetado.",
    A_N_Label: "Não há impacto na disponibilidade no componente afetado.",
    A_L_Label: "O desempenho é reduzido ou há interrupções na disponibilidade de recursos. Mesmo se a exploração repetida da vulnerabilidade for possível, o atacante não tem a capacidade de negar completamente o serviço a usuários legítimos. Os recursos do componente afetado estão parcialmente disponíveis o tempo todo, ou totalmente disponíveis apenas parte do tempo, mas, no geral, não há consequência direta e séria para o componente afetado.",
    A_H_Label: "Existe uma perda total de disponibilidade, resultando no atacante sendo capaz de negar completamente o acesso aos recursos no componente afetado; essa perda é tanto sustentada (enquanto o atacante continua entregando o ataque) ou persistente (a condição persiste mesmo depois que o ataque foi concluído). Alternativamente, o atacante tem a capacidade de negar alguma disponibilidade, mas a perda de disponibilidade apresenta uma consequência direta e séria ao componente afetado (por exemplo, o atacante não pode interromper as conexões existentes, mas pode evitar novas conexões; o atacante pode explorar repetidamente uma vulnerabilidade que, em cada instância de ataque bem-sucedido, vaza apenas uma pequena quantidade de memória, mas após exploração repetida, faz com que um serviço se torne completamente indisponível).",
    temporalMetricGroup_Legend: "As métricas Temporais medem o estado atual das técnicas de exploração ou disponibilidade de código, a existência de patches ou soluções alternativas, ou a confiança na descrição de uma vulnerabilidade.",
    E_Heading: "Essa métrica mede a probabilidade de a vulnerabilidade ser atacada e é tipicamente baseada no estado atual das técnicas de exploração, disponibilidade de código de exploração ou exploração ativa 'em campo'.",
    E_X_Label: "Atribuir esse valor indica que há informações insuficientes para escolher um dos outros valores, e não tem impacto na Pontuação Temporal geral, ou seja, tem o mesmo efeito na pontuação que atribuir Alto.",
    E_U_Label: "Nenhum código de exploração está disponível, ou uma exploração é teórica.",
    E_P_Label: "Código de exploração de prova de conceito está disponível, ou uma demonstração de ataque não é prática para a maioria dos sistemas. O código ou técnica não é funcional em todas as situações e pode exigir modificações substanciais por um atacante habilidoso.",
    E_F_Label: "Código de exploração funcional está disponível. O código funciona na maioria das situações onde a vulnerabilidade existe.",
    E_H_Label: "Código autônomo funcional existe, ou nenhuma exploração é necessária (acionamento manual) e os detalhes estão amplamente disponíveis. O código de exploração funciona em todas as situações, ou está sendo entregue ativamente por um agente autônomo (como um worm ou vírus). Sistemas conectados em rede provavelmente encontrarão tentativas de escaneamento ou exploração. O desenvolvimento de exploração atingiu o nível de ferramentas automatizadas confiáveis, amplamente disponíveis e de fácil utilização.",
    RL_Heading: "O Nível de Remediação de uma vulnerabilidade é um fator importante para a priorização. A vulnerabilidade típica não está corrigida quando é publicada inicialmente. Soluções alternativas ou correções temporárias podem oferecer remediação intermediária até que um patch oficial ou uma atualização seja emitido. Cada um desses estágios respectivos ajusta a pontuação temporal para baixo, refletindo a urgência decrescente à medida que a remediação se torna final.",
    RL_X_Label: "Atribuir esse valor indica que há informações insuficientes para escolher um dos outros valores, e não tem impacto na Pontuação Temporal geral, ou seja, tem o mesmo efeito na pontuação que atribuir Indisponível.",
    RL_O_Label: "Uma solução completa do fornecedor está disponível. Ou o fornecedor emitiu um patch oficial, ou uma atualização está disponível.",
    RL_T_Label: "Existe uma correção oficial temporária disponível. Isso inclui casos em que o fornecedor emite um hotfix temporário, ferramenta ou solução alternativa.",
    RL_W_Label: "Existe uma solução não oficial, não fornecida pelo fabricante, disponível. Em alguns casos, os usuários da tecnologia afetada criarão um patch próprio ou fornecerão etapas para contornar ou mitigar a vulnerabilidade.",
    RL_U_Label: "Não há solução disponível ou é impossível aplicá-la.",
    RC_Heading: "Essa métrica mede o grau de confiança na existência da vulnerabilidade e na credibilidade dos detalhes técnicos conhecidos. Às vezes, apenas a existência de vulnerabilidades é divulgada, mas sem detalhes específicos. Por exemplo, um impacto pode ser reconhecido como indesejável, mas a causa raiz pode não ser conhecida. A vulnerabilidade pode mais tarde ser corroborada por pesquisas que sugerem onde a vulnerabilidade pode estar, embora a pesquisa possa não ser certa. Finalmente, uma vulnerabilidade pode ser confirmada por meio do reconhecimento pelo autor ou fabricante da tecnologia afetada. A urgência de uma vulnerabilidade é maior quando se sabe que a vulnerabilidade existe com certeza. Essa métrica também sugere o nível de conhecimento técnico disponível para possíveis atacantes.",
    RC_X_Label: "Atribuir esse valor indica que há informações insuficientes para escolher um dos outros valores, e não tem impacto na Pontuação Temporal geral, ou seja, tem o mesmo efeito na pontuação que atribuir Confirmado.",
    RC_U_Label: "Existem relatos de impactos que indicam a presença de uma vulnerabilidade. Os relatórios indicam que a causa da vulnerabilidade é desconhecida, ou os relatórios podem diferir na causa ou nos impactos da vulnerabilidade. Os relatores estão incertos sobre a verdadeira natureza da vulnerabilidade, e há pouca confiança na validade dos relatórios ou se uma pontuação Base estática pode ser aplicada dadas as diferenças descritas. Um exemplo é um relatório de bug que observa que ocorre uma falha intermitente, mas não reproduzível, com evidências de corrupção de memória sugerindo que a negação de serviço ou possíveis impactos mais graves podem resultar.",
    RC_R_Label: "Detalhes significativos são publicados, mas os pesquisadores ou não têm plena confiança na causa raiz ou não têm acesso ao código-fonte para confirmar completamente todas as interações que podem levar ao resultado. No entanto, existe confiança razoável de que o bug é reproduzível e pelo menos um impacto pode ser verificado (provas de conceito podem fornecer isso). Um exemplo é um relatório detalhado de pesquisa sobre uma vulnerabilidade com uma explicação (possivelmente obfuscada ou 'deixada como exercício para o leitor') que dá garantias sobre como reproduzir os resultados.",
    RC_C_Label: "Relatórios detalhados existem, ou a reprodução funcional é possível (explorações funcionais podem fornecer isso). O código-fonte está disponível para verificar independentemente as afirmações da pesquisa, ou o autor ou fabricante do código afetado confirmou a presença da vulnerabilidade.",
    environmentalMetricGroup_Legend: "Essas métricas permitem que o analista personalize a pontuação CVSS dependendo da importância do ativo de TI afetado para a organização do usuário, medida em termos de controles de segurança complementares/alternativos em vigor, Confidencialidade, Integridade e Disponibilidade. As métricas são equivalentes modificadas das métricas base e recebem valores métricos com base no posicionamento do componente na infraestrutura da organização.",
    CR_Heading: "Essas métricas permitem que o analista personalize a pontuação CVSS dependendo da importância da Confidencialidade do ativo de TI afetado para a organização do usuário, em relação a outros impactos. Essa métrica modifica a pontuação ambiental ao reponderar a métrica de impacto de Confidencialidade Modificada em relação aos outros impactos modificados.",
    CR_X_Label: "Atribuir esse valor indica que há informações insuficientes para escolher um dos outros valores, e não tem impacto na Pontuação Ambiental geral, ou seja, tem o mesmo efeito na pontuação que atribuir Médio.",
    CR_L_Label: "A perda de Confidencialidade provavelmente terá apenas um efeito adverso limitado na organização ou indivíduos associados à organização (por exemplo, funcionários, clientes).",
    CR_M_Label: "Atribuir esse valor à métrica não influenciará a pontuação.",
    CR_H_Label: "A perda de Confidencialidade provavelmente terá um efeito adverso catastrófico na organização ou indivíduos associados à organização (por exemplo, funcionários, clientes).",
    IR_Heading: "Essas métricas permitem que o analista personalize a pontuação CVSS dependendo da importância da Integridade do ativo de TI afetado para a organização do usuário, em relação a outros impactos. Essa métrica modifica a pontuação ambiental ao reponderar a métrica de impacto de Integridade Modificada em relação aos outros impactos modificados.",
    IR_X_Label: "Atribuir esse valor indica que há informações insuficientes para escolher um dos outros valores, e não tem impacto na Pontuação Ambiental geral, ou seja, tem o mesmo efeito na pontuação que atribuir Médio.",
    IR_L_Label: "A perda de Integridade provavelmente terá apenas um efeito adverso limitado na organização ou indivíduos associados à organização (por exemplo, funcionários, clientes).",
    IR_M_Label: "Atribuir esse valor à métrica não influenciará a pontuação.",
    IR_H_Label: "A perda de Integridade provavelmente terá um efeito adverso catastrófico na organização ou indivíduos associados à organização (por exemplo, funcionários, clientes).",
    AR_Heading: "Essas métricas permitem que o analista personalize a pontuação CVSS dependendo da importância da Disponibilidade do ativo de TI afetado para a organização do usuário, em relação a outros impactos. Essa métrica modifica a pontuação ambiental ao reponderar a métrica de impacto de Disponibilidade Modificada em relação aos outros impactos modificados.",
    AR_X_Label: "Atribuir esse valor indica que há informações insuficientes para escolher um dos outros valores, e não tem impacto na Pontuação Ambiental geral, ou seja, tem o mesmo efeito na pontuação que atribuir Médio.",
    AR_L_Label: "A perda de Disponibilidade provavelmente terá apenas um efeito adverso limitado na organização ou indivíduos associados à organização (por exemplo, funcionários, clientes).",
    AR_M_Label: "Atribuir esse valor à métrica não influenciará a pontuação.",
    AR_H_Label: "A perda de Disponibilidade provavelmente terá um efeito adverso catastrófico na organização ou indivíduos associados à organização (por exemplo, funcionários, clientes).",
    MAV_Heading: "Essa métrica reflete o contexto pelo qual a exploração da vulnerabilidade é possível. A Pontuação Ambiental aumenta quanto mais remoto (logicamente e fisicamente) um atacante pode estar para explorar o componente vulnerável.",
    MAV_X_Label: "O valor atribuído à métrica Base correspondente é usado.",
    MAV_N_Label: "O componente vulnerável está ligado à pilha de rede e o conjunto de possíveis atacantes se estende além das outras opções listadas, incluindo a Internet inteira. Tal vulnerabilidade é frequentemente denominada 'explorável remotamente' e pode ser considerada como um ataque explorável no nível do protocolo a uma ou mais etapas de rede de distância.",
    MAV_A_Label: "O componente vulnerável está ligado à pilha de rede, mas o ataque está limitado no nível do protocolo a uma topologia logicamente adjacente. Isso pode significar que um ataque deve ser lançado a partir da mesma rede física compartilhada (por exemplo, Bluetooth ou IEEE 802.11) ou lógica (por exemplo, sub-rede IP local) ou de um domínio administrativo seguro ou limitado de outra forma (por exemplo, MPLS, VPN segura).",
    MAV_L_Label: "O componente vulnerável não está ligado à pilha de rede e o caminho do atacante é por meio de capacidades de leitura/escrita/execução. Ou o atacante explora a vulnerabilidade acessando o sistema de destino localmente (por exemplo, teclado, console) ou remotamente (por exemplo, SSH); ou o atacante depende da Interação do Usuário por outra pessoa para executar as ações necessárias para explorar a vulnerabilidade (por exemplo, enganar um usuário legítimo para abrir um documento malicioso).",
    MAV_P_Label: "O ataque requer que o atacante toque ou manipule fisicamente o componente vulnerável. A interação física pode ser breve ou persistente.",
    MAC_Heading: "Essa métrica descreve as condições além do controle do atacante que devem existir para explorar a vulnerabilidade. Tais condições podem exigir a coleta de mais informações sobre o alvo ou exceções computacionais. A avaliação dessa métrica exclui quaisquer requisitos de interação do usuário para explorar a vulnerabilidade. Se uma configuração específica for necessária para que um ataque tenha sucesso, as métricas Base devem ser pontuadas assumindo que o componente vulnerável está nessa configuração.",
    MAC_X_Label: "O valor atribuído à métrica Base correspondente é usado.",
    MAC_L_Label: "Condições de acesso especializado ou circunstâncias atenuantes não existem. Um atacante pode esperar sucesso repetível contra o componente vulnerável.",
    MAC_H_Label: "Um ataque bem-sucedido depende de condições além do controle do atacante. Ou seja, um ataque bem-sucedido não pode ser realizado a qualquer momento, mas requer que o atacante invista em alguma quantidade mensurável de esforço na preparação ou execução contra o componente vulnerável antes que um ataque bem-sucedido possa ser esperado. Por exemplo, um ataque bem-sucedido pode exigir que um atacante: obtenha conhecimento sobre o ambiente em que o alvo/componente vulnerável existe; prepare o ambiente de destino para melhorar a confiabilidade da exploração; ou injete-se no caminho de rede lógica entre o alvo e o recurso solicitado pela vítima para ler e/ou modificar comunicações de rede (por exemplo, um ataque de homem no meio).",
    MPR_Heading: "Essa métrica descreve o nível de privilégios que um atacante deve possuir antes de explorar com sucesso a vulnerabilidade.",
    MPR_X_Label: "O valor atribuído à métrica Base correspondente é usado.",
    MPR_N_Label: "O atacante não está autorizado antes do ataque e, portanto, não requer nenhum acesso a configurações ou arquivos para realizar um ataque.",
    MPR_L_Label: "O atacante está autorizado com (ou seja, requer) privilégios que fornecem capacidades básicas do usuário que normalmente poderiam afetar apenas configurações e arquivos de propriedade de um usuário. Alternativamente, um atacante com privilégios baixos pode ter a capacidade de causar um impacto apenas em recursos não sensíveis.",
    MPR_H_Label: "O atacante está autorizado com (ou seja, requer) privilégios que fornecem controle significativo (por exemplo, administrativo) sobre o componente vulnerável que poderia afetar configurações e arquivos em todo o componente.",
    MUI_Heading: "Essa métrica captura o requisito de um usuário, que não seja o atacante, para participar na comprometimento bem-sucedido do componente vulnerável. Essa métrica determina se a vulnerabilidade pode ser explorada apenas à vontade do atacante, ou se um usuário separado (ou processo iniciado pelo usuário) deve participar de alguma maneira.",
    MUI_X_Label: "O valor atribuído à métrica Base correspondente é usado.",
    MUI_N_Label: "O sistema vulnerável pode ser explorado sem interação de qualquer usuário.",
    MUI_R_Label: "A exploração bem-sucedida dessa vulnerabilidade requer que um usuário tome alguma ação antes que a vulnerabilidade possa ser explorada.",
    MS_Heading: "Um ataque bem-sucedido afeta um componente além do componente vulnerável? Se sim, a Pontuação Base aumenta e as métricas de Confidencialidade, Integridade e Autenticação devem ser pontuadas em relação ao componente afetado.",
    MS_X_Label: "O valor atribuído à métrica Base correspondente é usado.",
    MS_U_Label: "Uma vulnerabilidade explorada pode afetar apenas recursos gerenciados pela mesma autoridade de segurança. Nesse caso, o componente vulnerável e o componente afetado são iguais ou ambos são gerenciados pela mesma autoridade de segurança.",
    MS_C_Label: "Uma vulnerabilidade explorada pode afetar recursos além do escopo de segurança gerenciado pela autoridade de segurança do componente vulnerável. Nesse caso, o componente vulnerável e o componente afetado são diferentes e gerenciados por autoridades de segurança diferentes.",
    MC_Heading: "Essa métrica mede o impacto na confidencialidade dos recursos de informação gerenciados por um componente de software devido a uma vulnerabilidade explorada com sucesso. Confidencialidade refere-se a limitar o acesso e a divulgação de informações apenas a usuários autorizados, bem como a impedir o acesso ou a divulgação a usuários não autorizados.",
    MC_X_Label: "O valor atribuído à métrica Base correspondente é usado.",
    MC_N_Label: "Não há perda de confidencialidade no componente afetado.",
    MC_L_Label: "Há alguma perda de confidencialidade. O acesso a algumas informações restritas é obtido, mas o atacante não tem controle sobre quais informações são obtidas, ou a quantidade ou tipo de perda é limitada. A divulgação de informações não causa uma perda direta e séria no componente afetado.",
    MC_H_Label: "Há perda total de confidencialidade, resultando na divulgação de todos os recursos no componente afetado para o atacante. Alternativamente, o acesso a apenas algumas informações restritas é obtido, mas as informações divulgadas apresentam um impacto direto e sério.",
    MI_Heading: "Essa métrica mede o impacto na integridade de uma vulnerabilidade explorada com sucesso. Integridade refere-se à confiabilidade e veracidade das informações.",
    MI_X_Label: "O valor atribuído à métrica Base correspondente é usado.",
    MI_N_Label: "Não há perda de integridade no componente afetado.",
    MI_L_Label: "A modificação de dados é possível, mas o atacante não tem controle sobre a consequência de uma modificação, ou a quantidade de modificação é limitada. A modificação de dados não tem um impacto direto e sério no componente afetado.",
    MI_H_Label: "Há uma perda total de integridade ou uma perda completa de proteção. Por exemplo, o atacante é capaz de modificar todos os arquivos protegidos pelo componente afetado. Alternativamente, apenas alguns arquivos podem ser modificados, mas a modificação maliciosa apresentaria uma consequência direta e séria para o componente afetado.",
    MA_Heading: "Essa métrica mede o impacto na disponibilidade do componente afetado resultante de uma vulnerabilidade explorada com sucesso. Refere-se à perda de disponibilidade do próprio componente afetado, como um serviço em rede (por exemplo, web, banco de dados, email). Como a disponibilidade se refere à acessibilidade de recursos de informação, ataques que consomem largura de banda de rede, ciclos de processador ou espaço em disco afetam a disponibilidade de um componente afetado.",
    MA_X_Label: "O valor atribuído à métrica Base correspondente é usado.",
    MA_N_Label: "Não há impacto na disponibilidade no componente afetado.",
    MA_L_Label: "O desempenho é reduzido ou há interrupções na disponibilidade de recursos. Mesmo que a exploração repetida da vulnerabilidade seja possível, o atacante não tem a capacidade de negar completamente o serviço a usuários legítimos. Os recursos no componente afetado estão parcialmente disponíveis o tempo todo, ou totalmente disponíveis apenas parte do tempo, mas no geral não há uma consequência direta e séria no componente afetado.",
    MA_H_Label: "Há perda total de disponibilidade, resultando no atacante sendo capaz de negar completamente o acesso aos recursos no componente afetado; essa perda é sustentada (enquanto o atacante continua a realizar o ataque) ou persistente (a condição persiste mesmo depois que o ataque foi concluído). Alternativamente, o atacante tem a capacidade de negar alguma disponibilidade, mas a perda de disponibilidade apresenta uma consequência direta e séria no componente afetado (por exemplo, o atacante não pode interromper conexões existentes, mas pode impedir novas conexões; o atacante pode explorar repetidamente uma vulnerabilidade que, em cada instância de um ataque bem-sucedido, vaza apenas uma pequena quantidade de memória, mas após explorações repetidas faz com que um serviço fique completamente indisponível)."
  }
},
registerFirstUser: 'Registrar Primeiro Usuário',
customData: 'Dados Personalizados',
custom: 'Personalizado',
settings: 'Configurações',
profile: 'Perfil',
logout: 'Sair',
login: 'Login',
username: 'Nome de Usuário',
password: 'Senha',
noLanguage: 'Nenhum idioma definido. Por favor, crie Idiomas em ',
noAudit: 'Nenhum tipo de Auditoria definido. Por favor, crie Tipos de Auditoria em ',
auditTypes: 'Tipos de Auditoria',
auditType: 'Tipo de Auditoria',
searchFinds: 'Buscar Descoberta',
myAudits: 'Minhas Auditorias',
usersConnected: 'Usuários Conectados',
awaitingMyReview: 'Aguardando minha revisão',
newAudit: 'Nova Auditoria',
search: 'Buscar',
searchUsersPlaceholder: 'Buscar usuários por nome, e-mail ou nome de usuário...',
any: 'Qualquer',
all: 'Todos',
status: 'Status',
actions: 'Ações',
statusActive: 'Ativo',
statusDisabled: 'Desabilitado',
enabled: 'habilitada',
disabled: 'desabilitada',
showing: 'Mostrando',
to: 'a',
of: 'de',
user: 'Usuário',
users: 'Usuários',
userSelected: 'usuário selecionado',
usersSelected: 'usuários selecionados',
allRoles: 'Todas as funções',
twoFactorAuthentication: '2FA',
forThisUser: 'para este usuário',
disableUsersWarning: 'Usuários desabilitados não poderão entrar ou acessar o sistema. Você pode reabilitá-los a qualquer momento.',
auditNum1: 'Auditoria',
auditNums: 'Auditorias',
resultsPerPage: 'Resultados por página:',
createAudit: 'Criar Auditoria',
name: 'Nome',
shortName: 'Nome Curto',
selectAssessment: 'Selecionar Avaliação',
selectLanguage: 'Selecionar Idioma',
participants: 'Participantes',
language: 'Idioma',
company: 'Empresa',
companies: 'Empresas',
date: 'Data',
sections: 'Seções',
generalInformation: 'Informações Gerais',
networkScan: 'Varredura de Rede',
findings: 'Descobertas',
automaticSorting: 'Ordenação Automática',
sortBy: 'Ordenar Por',
sortOrder: 'Ordem de Classificação',
ascending: 'Crescente',
descending: 'Decrescente',
newestFirst: 'Mais Recente Primeiro',
oldestFirst: 'Mais Antigo Primeiro',
me: 'eu',
cvssScore: 'Pontuação CVSS',
cvssTemporalScore: 'Pontuação Temporal CVSS',
cvssEnvironmentalScore: 'Pontuação Ambiental CVSS',
priority: 'Prioridade',
remediation: 'Remediação',
remediationDifficulty: 'Dificuldade de Remediação',
remediationComplexity: 'Complexidade de Remediação',
remediationPriority: 'Prioridade de Remediação',
easy: 'Fácil',
medium: 'Médio',
complex: 'Complexo',
low: 'Baixa',
high: 'Alta',
urgent: 'Urgente',
title: 'Título',
category: 'Categoria',
selectCategory: 'Selecionar Categoria',
noCategory: 'Sem Categoria',
vulnType: 'Tipo',
undefined: 'Indefinido',
vulnerabilityNum1: 'Vulnerabilidade',
vulnerabilitiesNums: 'Vulnerabilidades',
definition: 'Definição',
proofs: 'Provas',
details: 'Detalhes',
completed: 'Concluído',
type: 'Tipo',
lastModified: 'Última Modificação',
description: 'Descrição',
observation: 'Observação',
references: 'Referências',
one_per_line: '(Um por linha)',
customFields: 'Campos Personalizados',
affectedAssets: 'Ativos Afetados',
courseOfActions: 'Caminho de Ações',
template: 'Modelo',
client: 'Cliente',
reviewers: 'Revisores',
collaborator: 'Colaborador',
collaborators: 'Colaboradores',
startDate: 'Data de Início',
endDate: 'Data de Término',
reportingDate: 'Data de Relatório',
auditScope: 'Escopo da Auditoria (Um por linha)',
import: 'Importar',
export: 'Exportar',
hostsAssociateScopes: 'Associar hosts importados com Escopos',
handleCustomData: 'Lidar com Dados Personalizados',
clients: 'Clientes',
templates: 'Modelos',
addClient: 'Adicionar Cliente',
editClient: 'Editar Cliente',
firstname: 'Nome',
lastname: 'Sobrenome',
email: 'E-mail',
function: 'Função',
phone: 'Telefone',
cell: 'Celular',
jobTitle: 'Cargo',
role: 'Função',
collatorator: 'Colaborador',
addCollaborator: 'Adicionar Colaborador',
editCollaborator: 'Editar Colaborador',
addCompany: 'Adicionar Empresa',
editCompany: 'Editar Empresa',
logo: 'Logo',
quantifier: '',
languages: 'Idiomas',
extension: 'Extensão',
createTemplate: 'Criar Modelo',
file: 'Arquivo',
editTemplate: 'Editar Modelo',
importVulnerabilities: 'Importar Vulnerabilidades',
importVulnerabilitiesInfo: 'Importar Vulnerabilidades de um arquivo .yml ou .json. (Formato Serpico aceito)<br />Isso permite importar um lote de modelos de vulnerabilidade facilmente.',
importVulnerabilitiesOk: 'Todas as <strong>{0}</strong> vulnerabilidades criadas',
importVulnerabilitiesAllExists: 'Todos os títulos de <strong>{0}</strong> vulnerabilidades já existem',
importVulnerabilitiesPartial: '<strong>{0}</strong> vulnerabilidades criadas<br /><strong>{1}</strong> títulos de vulnerabilidades já existem',
exportVulnerabilities: 'Exportar Vulnerabilidades',
exportVulnerabilitiesInfo: 'Exportar Vulnerabilidades no formato yaml. Essa exportação pode ser facilmente reimportada posteriormente',
deleteAllVulnerabilities: 'Excluir Todas as Vulnerabilidades',
deleteAllVulnerabilitiesInfo: 'Excluir todas as vulnerabilidades existentes.<br /><strong>Essa ação é definitiva!!</strong>',
customSections: 'Seções Personalizadas',
listOfLanguages: 'Lista de Idiomas',
editLanguages: 'Editar Idiomas',
locale: 'Local',
auditTypesUsedInAudits: 'Tipos de auditoria usados em Auditorias',
languageUsedInAuditsAndVuls: 'Idiomas usados em Auditorias e Vulnerabilidades',
addSections: 'Adicionar Seções',
hideBuiltInSections: 'Ocultar Seções Incorporadas',
listOfAuditTypes: 'Lista de Tipos de Auditoria',
editAuditTypes: 'Editar Tipos de Auditoria',
createAtLeastOneLanguage: 'Por favor, crie pelo menos um Idioma',
createVulnerabilityTypes: 'Criar tipos de vulnerabilidade usados em Vulnerabilidades e Descobertas',
vulnerabilityTypesList: 'Lista de Tipos de Vulnerabilidade',
editVulnerabilityTypes: 'Editar Tipos de Vulnerabilidade',
createVulnerabilityCategories: 'Criar categorias de vulnerabilidade usadas em Vulnerabilidades e Descobertas',
defaultSortingOptions: 'Opções de Classificação Padrão',
listOfCategories: 'Lista de Categorias',
editCategories: 'Editar Categorias',
createAndManageCustomFields: 'Criar e gerenciar Campos Personalizados para diferentes Visualizações',
selectView: 'Selecionar Visualização',
selectSection: 'Selecionar Seção',
selectComponent: 'Selecionar Componente',
label: 'Rótulo',
size: 'Tamanho',
offset: 'Offset',
required: 'Obrigatório',
optionsLanguage: 'Idioma das Opções',
addOption: 'Adicionar Opção',
languageForDefaultText: 'Idioma (Para texto padrão)',
createCustomSections: 'Criar Seções Personalizadas usadas em Auditorias',
fieldForTemplate: 'Campo (Para Modelo)',
customIcon: 'Ícone (Material/Font Awesome)',
field: 'Campo',
editSections: 'Editar Seções',
vulnerabilityTypes: 'Tipos de Vulnerabilidade',
vulnerabilityCategories: 'Categorias de Vulnerabilidade',
auditGeneral: 'Geral da Auditoria',
auditFinding: 'Descoberta da Auditoria',
auditSection: 'Seção da Auditoria',
vulnerability: 'Vulnerabilidade',
checkbox: 'Caixa de Seleção',
editor: 'Editor',
input: 'Entrada',
radio: 'Botão de Rádio',
select: 'Seleção',
selectMultiple: 'Seleção Múltipla',
space: 'Espaço',
updateUserInformation: 'Atualizar Informações do Usuário',
newPassword: 'Nova Senha',
confirmPassword: 'Confirmar Senha',
currentPassword: 'Senha Atual *',
reports: 'Relatórios',
reportsImagesBorder: 'Borda de Imagens em Relatórios',
addBorderToImages: 'Adicionar borda às imagens no relatório gerado.',
currentColor: 'Cor atual',
cvssColors: 'Cores do CVSS',
changeCvssColorsDescription: 'Altera as cores usadas no relatório para representar as diferentes severidades do CVSS.',
critical: 'Crítico',
informational: 'Informativo',
reviews: 'Revisões',
auditUpdateAfterApproval: 'Atualização da Auditoria Após Aprovação',
changeApproveBehaviorIfAuditUpdated: 'Altera o comportamento para uma auditoria aprovada que é atualizada. Se uma auditoria for atualizada: ',
removeAllPriorApprovals: 'Todas as aprovações anteriores serão removidas.',
keepAllPriorApprovals: 'Todas as aprovações anteriores serão mantidas.',
mandatoryReview: 'Revisão Obrigatória',
mandatoryReviewInfo: `Torna o processo de revisão obrigatório. Quando ativado, um usuário não pode exportar uma auditoria a menos que tenha sido aprovado pelo número especificado de revisores.
<br/>O número mínimo de revisores também é usado para determinar se um relatório é marcado como aprovado.`,
minimalNumberOfReviewers: 'Número mínimo de revisores',
saveSettings: 'Salvar configurações',
revertSettingsToDefaults: 'Reverter configurações para padrão',
importSettings: 'Importar configurações',
exportSettings: 'Exportar configurações',
mergeVulnerabilities: 'Fundir Vulnerabilidades',
mergeVulnerabilitiesInfo: `O objetivo é fundir diferentes vulnerabilidades com diferentes idiomas na mesma vulnerabilidade.<br />
Portanto, um mínimo de 2 idiomas deve existir.`,
newVulnerability: 'Nova Vulnerabilidade',
createNewVulnerability: 'Criar uma nova vulnerabilidade',
filters: 'Filtros',
views: 'Visualizações',
or: 'ou',
reset: 'Redefinir',
createdBy: 'Criado por',
filtersApplied: 'filtro(s) aplicado(s)',
unsavedChangesOnly: 'Somente alterações não salvas',
noMatchingRecords: 'Nenhum registro correspondente encontrado',
selectVulnerability: 'Selecione uma vulnerabilidade para visualizar ou editar',
selectVulnerabilityHint: 'Escolha uma vulnerabilidade na lista à esquerda para ver seus detalhes, pontuação CVSS, referências e mais.',
total: 'Total',
addVulnerability: 'Adicionar Vulnerabilidade',
editVulnerability: 'Editar Vulnerabilidade',
changeCategory: 'Mudar Categoria',
listOfSections: 'Lista de Seções',
updateVulnerability: 'Atualizar Vulnerabilidade',
current: 'Atual',
proposalsCount: '{count} proposta | {count} propostas',
reviewVulnerabilityProposals: 'Revisar propostas de vulnerabilidade',
currentVersion: 'Versão atual',
proposedVersion: 'Versão proposta',
today: 'Hoje',
yesterday: 'Ontem',
languageAddFromRight: 'Idioma (Adicionar da direita)',
languageMoveToLeft: 'Idioma (Mover para a esquerda)',
merge: 'Fundir',
goBack: 'Voltar',
twoStepVerification: 'Verificação em Duas Etapas',
twoStepVerificationMessage: 'Abra seu aplicativo de autenticação e insira o código de segurança que ele fornece.',
captions: 'Legendas',
captionsDescription: 'Adicione rótulos de legendas que serão usados no relatório (O padrão é \'Figura\')',
highlightWarning: 'Destacar Aviso',
highlightWarningDescription: `Adicione uma mensagem de aviso ao editar um relatório e texto destacado na cor especificada ainda estiver presente.<br />
Útil para texto genérico que deve ser substituído pelo repórter.`,
defaultFieldsRequired: 'Campos Padrão',
defaultFieldsRequiredDescription: 'Gerenciar a exigência de Campos Padrão em Auditorias',
general: 'Geral',
scope: 'Escopo',
fieldIsRequired: 'Campo é obrigatório',
corrected: 'Corrigido',
not_corrected: 'Não Corrigido',
partially_corrected: 'Parcialmente Corrigido',
not_verifiable: 'Não Verificável',
audits: 'Auditorias',
multi: 'Multi-Fases',
retest: 'Reteste',
default: 'Padrão',
audit: 'Auditoria',
originalAudit: 'Auditoria Original',
willBeRemoved: 'será removido',
auditPhase: 'Fase da Auditoria',
spellcheck: 'Verificação ortográfica',
enableSpellcheck: 'Ativar verificação ortográfica',
spellcheckCategories: 'Categorias',
spellcheckCategory: {
    CASING: { label: 'Capitalização', description: 'Capitalização incorreta, ex. "inglês" em vez de "Inglês"' },
    COMPOUNDING: { label: 'Composição', description: 'Erros com palavras compostas, ex. hífens ausentes' },
    GRAMMAR: { label: 'Gramática', description: 'Erros gramaticais como formas verbais incorretas' },
    TYPOS: { label: 'Erros de digitação', description: 'Palavras mal escritas e erros de digitação comuns' },
    PUNCTUATION: { label: 'Pontuação', description: 'Sinais de pontuação ausentes ou incorretos' },
    TYPOGRAPHY: { label: 'Tipografia', description: 'Problemas tipográficos como aspas ou travessões incorretos' },
    CONFUSED_WORDS: { label: 'Palavras confundidas', description: 'Palavras frequentemente confundidas' },
    REPETITIONS: { label: 'Repetições', description: 'Palavras ou frases repetidas involuntariamente' },
    REDUNDANCY: { label: 'Redundância', description: 'Palavras redundantes que não acrescentam significado' },
    STYLE: { label: 'Estilo', description: 'Sugestões de estilo para escrita mais clara ou concisa' },
    SEMANTICS: { label: 'Semântica', description: 'Palavras usadas com significado incorreto' },
    COLLOQUIALISMS: { label: 'Coloquialismos', description: 'Expressões informais ou coloquiais' },
    MISC: { label: 'Miscelânea', description: 'Outras regras não cobertas pelas categorias acima' },
},
draftRecovery: {
    title: 'Alterações recuperadas',
    message: 'Revise as diferenças entre suas alterações recuperadas e a última versão salva.',
    savedAt: 'Salvo localmente em',
    currentVersion: 'Última versão salva',
    draftVersion: 'Suas alterações recuperadas',
    noDifferences: 'Nenhuma diferença encontrada',
    unifiedView: 'Unificado',
    splitView: 'Dividido',
    localDraftLabel: 'Alterações recuperadas',
    serverVersionLabel: 'Versão do servidor',
    localDraftExists: 'Existem alterações recuperadas',
    viewingLocalDraft: 'Você está visualizando suas alterações recuperadas',
    notSavedToServer: 'Salve para preservar suas alterações',
    viewingServerVersion: 'Você está visualizando a última versão salva',
    localDraftNotApplied: 'Existem alterações recuperadas mas não foram aplicadas',
    draftExpiresIn: 'Expira em',
    draftExpired: 'Expirado',
    clearedAfterInactivity: 'Recuperável até então',
    discardDraft: 'Reverter para versão salva',
    discardLocalChanges: 'Retornar à última versão salva',
    viewChangesLabel: 'Ver alterações',
    reviewChangesInDraft: 'Revisar alterações neste rascunho',
    restoreDraftLabel: 'Restaurar alterações recuperadas',
    replaceWithDraft: 'Substituir conteúdo atual pelas alterações recuperadas',
    deletePermanently: 'Excluir alterações recuperadas permanentemente',
    actionCannotBeUndone: 'Esta ação não pode ser desfeita',
    compareWithDraft: 'Comparar versão salva com as alterações recuperadas',
    saveHint: 'Use Salvar (ctrl+s) na barra de ferramentas para salvar suas alterações.',
    edited: 'Editado',
    editedJustNow: 'Editado agora'
},
    roles: 'Roles',
    rolesPageSubtitle: 'Gerencie funções e suas permissões. Funções definem o que usuários podem acessar e fazer.',
    createRole: 'Create Role',
    editRole: 'Edit Role',
    viewRole: 'View Role',
    deleteRole: 'Delete Role',
    searchRolesPlaceholder: 'Buscar funções...',
    allTypes: 'Todos os tipos',
    customRole: 'Personalizada',
    adminRoleDescription: 'Acesso completo à plataforma. Gerencia todas as configurações, usuários e dados.',
    userRoleDescription: 'Acesso básico para visualizar dados atribuídos.',
    roleDescriptionFallback: 'Nenhuma descrição fornecida.',
    allPermissions: 'Todas as permissões',
    roleDisplayName: 'Display Name',
    roleName: 'Role Name',
    roleNameImmutableHint: 'Cannot be changed after creation',
    permissions: 'Permissions',
    coreAccess: 'Core Access',
    featurePermissions: 'Feature Permissions',
    cloneFrom: 'Clone From',
    searchPermissions: 'Search permissions...',
    selected: 'selected',
    assigned: 'assigned',
    expandAll: 'Expand all',
    collapseAll: 'Collapse all',
    clearAll: 'Clear all',
    noPermissionsFound: 'No permissions found',
    systemRole: 'System',
    cannotEditSystemRole: 'System roles cannot be edited',
    usersWithRole: 'Users with this role',
    roleType: 'Type',
    addRoles: 'Add Roles',
    removeRoles: 'Remove Roles',
    bulkActionsSelected: 'Bulk actions selected',
    auditQa: {
        infos: 'Infos',
        title: 'Revisão de QA',
        loading: 'Carregando resultados de QA…',
        running: 'Executando verificações de QA...',
        runInProgress: 'QA em andamento… iniciado {time}',
        runInProgressNoTime: 'QA em andamento…',
        runInProgressProgrammatic: 'Verificações programáticas em andamento… iniciado {time}',
        runInProgressProgrammaticNoTime: 'Verificações programáticas em andamento…',
        runInProgressAi: 'Verificações com IA em andamento… iniciado {time}',
        runInProgressAiNoTime: 'Verificações com IA em andamento…',
        failed: 'Não foi possível executar a revisão de QA do relatório',
        previousProgrammaticRun: 'Exibindo dados das verificações integradas',
        previousProgrammaticRunAt: 'Exibindo dados das verificações integradas ({date})',
        previousAiRun: 'Exibindo dados das verificações com IA',
        previousAiRunAt: 'Exibindo dados das verificações com IA ({date})',
        runSourceProgrammatic: 'Verificações integradas',
        runSourceAi: 'Verificações com IA',
        lastRun: 'Última execução',
        noResultsYet: 'Ainda não há resultados de QA. Escolha uma opção de execução acima.',
        outdatedBanner: 'Estes resultados estão desatualizados — o conteúdo mudou desde a última execução. Recomenda-se executar novamente.',
        runProgrammatic: 'Executar Verificações Integradas',
        runAi: 'Executar Verificações com IA',
        runAll: 'Executar verificações integradas + IA',
        runAgain: 'Executar novamente',
        runAgainScoped: 'Executar novamente {scope}',
        scopeProgrammatic: 'Verificações integradas',
        scopeAi: 'Verificações com IA',
        scopeAll: 'Verificações integradas + IA',
        errors: 'Erros',
        warnings: 'Avisos',
        total: 'Total',
        filterAll: 'Todos',
        noIssues: 'Nenhum problema sinalizado',
        goToFinding: 'Ir para a descoberta',
        goToSection: 'Ir para a seção',
        aiReview: 'Revisão por IA — verifique antes de agir',
        showMore: 'Mostrar mais {count}',
        category: {
            completeness: 'Completude',
            redaction: 'Redação',
            customer: 'Cliente',
            instructions: 'Instruções de QA',
            references: 'Referências',
            imageCaptions: 'Legendas de imagens',
            duplicates: 'Duplicatas',
            aiDuplicates: 'Duplicatas por IA',
            aiUnlinkedTranslations: 'Traduções não vinculadas',
            other: 'Outros'
        },
        location: {
            general: 'Informações gerais',
            network: 'Rede',
            report: 'Relatório',
            untitledFinding: 'Descoberta sem título'
        }
    },
    vulnerabilityQa: {
        titleSingle: 'Revisão de QA',
        titleAll: 'Revisão de QA do Banco de Dados de Vulnerabilidades',
        untitled: 'Vulnerabilidade sem título',
        loading: 'Carregando resultados de QA…',
        running: 'Revisando vulnerabilidades quanto à completude, entradas duplicadas, links de referência e diretrizes de conteúdo...',
        failed: 'Não foi possível executar a revisão de QA das vulnerabilidades',
        recheckFailed: 'Não foi possível reverificar a vulnerabilidade',
        showReview: 'Mostrar revisão de QA',
        hideReview: 'Ocultar revisão de QA',
        reviewedCount: '{count} vulnerabilidades revisadas para o idioma selecionado.',
        runAllPreview: 'Revisa todas as {count} vulnerabilidades em {language} com verificações de completude, duplicatas e IA. Executa em segundo plano — você pode continuar trabalhando.',
        progressTemplates: '{processed} de {total} vulnerabilidades verificadas…',
        progressCatalog: 'Verificações entre vulnerabilidades: {done} de {total}…',
        reusedCached: '{count} resultado(s) inalterado(s) reutilizado(s)',
        partialReport: '{checked} de {total} vulnerabilidades verificadas — execute o QA novamente para revisar as restantes.',
        cancel: 'Cancelar',
        recheckHint: 'Reverifica apenas esta vulnerabilidade. Verificações entre vulnerabilidades (duplicatas, traduções) não estão incluídas — use "Executar novamente" para elas.',
        recheckUpToDate: 'Atualizado — nenhuma alteração desde a última execução de QA',
        runAgainHint: 'Somente vulnerabilidades desatualizadas são reverificadas',
        rowOutdated: 'desatualizada',
        catalogGroup: 'Verificações entre vulnerabilidades',
        goToVulnerability: 'Ir para a vulnerabilidade',
        resolve: 'Resolver esta vulnerabilidade',
        resolveIssue: 'Resolver este problema',
        unresolve: 'Marcar como não resolvida',
        resolvedLabel: 'resolvida',
        filterActive: 'Ativas',
        filterOutdated: 'Desatualizadas',
        filterResolved: 'Resolvidas',
        filterAllStatus: 'Todas',
        filterRows: 'Filtrar por título da vulnerabilidade...',
        resolveFailed: 'Não foi possível atualizar o estado de resolução',
        clearFilters: 'Limpar filtros',
        notFoundInList: 'Esta vulnerabilidade não está mais no banco de dados — execute o QA novamente para atualizar o relatório.',
        notVisibleWithFilters: 'Esta vulnerabilidade está oculta pelos filtros atuais.',
        location: {
            database: 'Banco de dados de vulnerabilidades',
            global: 'Global'
        }
    },
    aiIntegration: {
        pageTitleWriting: 'Assisted Writing',
        pageTitleQa: 'Quality Assurance',
        disabledBanner: 'AI integration is disabled in organization settings. Enable it from Settings to manage assisted writing and quality assurance.',
        noPermissionBanner: 'You do not have permission to view {page} settings.',
        loadFailed: 'Failed to load AI integration settings',
        tabPrompts: 'Prompts',
        tabGuidelines: 'Writing Guidelines',
        tabProgrammaticChecks: 'Built-in Checks',
        tabAiChecks: 'AI Checks',
        prompts: {
            description: "Configure generic prompts for the AI chat and field-specific generation prompts. Provider and model settings are managed in Settings.",
            readOnly: 'Read-only: you do not have permission to update prompts.',
            genericPrompts: 'Generic Prompts',
            categoriesAndFields: 'Prompts & Fields',
            nodeFindings: 'Findings',
            nodeBuiltinFields: 'Built-in fields',
            nodeAllCategories: 'All categories',
            nodeVulnerabilities: 'Vulnerabilities',
            nodeSections: 'Sections',
            nodeAllSections: 'All sections',
            searchAllPlaceholder: 'Search',
            filterPlaceholder: 'Search by field name',
            globalCaption: 'Reusable prompts listed in the AI chat in this order (spellcheck, translation, style rewrites, etc.). Drag to reorder.',
            noGlobalPrompts: 'No generic prompts yet. Add one to expose document-wide actions in the AI chat.',
            noFieldsMatch: 'No fields match your search.',
            addGlobalPrompt: 'Add prompt',
            deleteSelected: 'Delete selected ({count})',
            deletePrompt: 'Delete prompt',
            deleteConfirmTitle: 'Delete generic prompt(s)',
            deleteConfirmMessage: 'Delete {count} generic prompt(s)? This cannot be undone.',
            deleteSuccess: '{count} generic prompt(s) deleted',
            columnField: 'Field',
            columnPrompt: 'Prompt',
            aiAssist: 'AI Assist',
            label: 'Label',
            labelHint: 'Shown in the AI chat (e.g. Spellcheck my document)',
            enabled: 'Enabled',
            disabled: 'Desativado',
            prompt: 'Prompt',
            newPrompt: 'New prompt',
            saveChanges: 'Save changes',
            resetToDefault: 'Reset to default',
            resetConfirmTitle: 'Reset prompt',
            resetConfirmMessage: 'Reset the "{field}" prompt to its default text?',
            resetSuccess: 'Prompt reset to default',
            discardChangesTitle: 'Unsaved changes',
            discardChangesMessage: 'You have unsaved changes to this prompt. Discard them and continue?',
            variablesTitle: 'Available variables',
            saveSuccess: 'Assisted writing prompts updated successfully',
            saveFailed: 'Failed to update assisted writing prompts',
            unsavedChanges: '{count} unsaved change(s)',
            outputTypeHtml: 'HTML',
            outputTypeList: 'List',
            outputTypeText: 'Text'
        },
        guidelines: {
            description: 'Organization-wide writing rules provided to every AI request as additional context. Use plain text or Markdown, similar to a project style guide.',
            readOnly: 'Read-only: you do not have permission to update writing guidelines.',
            label: 'Writing guidelines',
            hint: 'Examples: tone, terminology, data redaction rules, forbidden disclosures, report structure conventions.',
            save: 'Save guidelines',
            saveSuccess: 'Writing guidelines updated successfully',
            saveFailed: 'Failed to update writing guidelines'
        },
        qa: {
            description: 'Configure which automated checks run when reviewing audit reports and vulnerability templates.',
            readOnly: 'Read-only: you do not have permission to update QA settings.',
            aiChecksDisabledChip: 'Desabilitado',
            aiChecksDisabledBefore: 'A integração com IA está desabilitada. Habilite-a em',
            aiChecksDisabledLink: 'Configurações',
            aiChecksDisabledAfter: 'para executar verificações com IA.',
            instructionsTitle: 'QA instructions',
            instructionsDescription: 'Organization-wide QA checklist provided to the AI reviewer. Use plain text or Markdown to define additional required sections, fields, and report rules beyond the minimum completeness check.',
            instructionsLabel: 'QA instructions',
            instructionsHint: 'Examples: require executive summary and scope sections, mandate remediation text, verify customer naming, retest wording.',
            save: 'Save QA settings',
            saveInstructions: 'Save instructions',
            saveSuccess: 'QA settings updated successfully',
            saveFailed: 'Failed to update QA settings',
            saved: 'Saved',
            checkCompletenessLabel: 'Report completeness',
            checkCompletenessDescription: 'Minimum report requirements only: audit name, at least one finding, and finding titles. Findings still in redaction are flagged as warnings.',
            checkReferencesLabel: 'Reference links',
            checkReferencesDescription: 'Validate that HTTP(S) URLs listed in finding references are reachable.',
            checkImageCaptionsLabel: 'Image captions',
            checkImageCaptionsDescription: 'Flag images and figure captions that still use the imported filename (for example screenshot.png).',
            checkDuplicatesLabel: 'Duplicate templates',
            checkDuplicatesDescription: 'Fast structural checks for templates in the same language with the same title or identical description, observation, and remediation content.',
            checkAiDuplicatesLabel: 'AI duplicate templates',
            checkAiDuplicatesDescription: 'AI review to identify templates that describe the same underlying vulnerability even when titles differ or content is paraphrased.',
            checkAiUnlinkedTranslationsLabel: 'AI unlinked translations',
            checkAiUnlinkedTranslationsDescription: 'AI review to identify the same vulnerability template stored in separate records for different languages instead of being merged into one multilingual record.',
            checkRedactionLabel: 'Writing guidelines review',
            checkRedactionDescription: 'AI review of report content against organization writing guidelines.',
            checkCustomerLabel: 'Customer alignment',
            checkCustomerDescription: 'AI review that the report content matches the expected customer and company.',
            checkInstructionsLabel: 'QA instructions',
            checkInstructionsDescription: 'AI review against organization QA instructions below, including any additional required sections or fields you define.',
            usesTokens: 'Uses tokens',
            scopeAudit: 'Audit reports',
            scopeVulnerability: 'Vulnerability database'
        },
        settingsCard: {
            title: 'AI Integration',
            disableHint: 'Disable to fully hide AI prompt configuration and AI generation buttons for all users.',
            providerTitle: 'AI Provider'
        },
        menu: {
            assistedWriting: 'Assisted Writing',
            qualityAssurance: 'Quality Assurance'
        },
        provider: {
            defaultBadge: 'Default',
            setDefaultLabel: 'Set as default provider',
            setDefaultHint: 'Used when a request does not specify a provider. Always available to users.',
            configuredHint: 'This provider is configured',
            allowUsersLabel: 'Allow users to select this provider',
            allowUsersHint: 'When enabled, users can pick this provider for AI generation and QA. The default provider is always available.',
            openaiBaseUrl: 'OpenAI Base URL',
            openaiModel: 'OpenAI Model',
            openaiApiKey: 'OpenAI API Key',
            anthropicBaseUrl: 'Anthropic Base URL',
            anthropicModel: 'Anthropic Model',
            anthropicVersion: 'Anthropic Version',
            anthropicApiKey: 'Anthropic API Key',
            deepseekBaseUrl: 'DeepSeek Base URL',
            deepseekModel: 'DeepSeek Model',
            deepseekApiKey: 'DeepSeek API Key',
            ollamaBaseUrl: 'Ollama Base URL',
            ollamaModel: 'Ollama Model',
            ollamaApiKey: 'Ollama API Key',
            awsRegion: 'AWS Region',
            bedrockModelId: 'Bedrock Model ID',
            bedrockCredentialsHint: 'Configure either a Bedrock API key or IAM credentials.',
            bedrockApiKey: 'Bedrock API Key',
            awsAccessKeyId: 'AWS Access Key ID',
            awsSecretAccessKey: 'AWS Secret Access Key',
            awsSessionToken: 'AWS Session Token (optional)',
            testConnection: 'Test connection',
            testSuccess: 'Connection successful',
            testSuccessWithModel: 'Connection successful (model: {model})',
            testFailed: 'Connection failed'
        }
    },
    aiChat: {
        providerLabel: 'Provider',
        selectedText: 'Texto selecionado',
        startPrompt: 'Descreva como você quer alterar o texto selecionado.',
        reviewDefaultPrompt: 'Escolha um prompt ou pergunte qualquer coisa.',
        defaultPromptPlaceholder: 'Pergunte qualquer coisa',
        askAnything: 'Pergunte qualquer coisa',
        defaultPromptOption: 'Padrão do campo',
        promptSelectLabel: 'Modelo de prompt',
        howCanIHelp: 'Como posso ajudar?',
        quickPrompts: 'Prompts rápidos',
        quickPromptsHint: 'Comece com o padrão do campo ou escolha um prompt reutilizável.',
        searchPrompts: 'Pesquisar prompts...',
        searchResults: 'Resultados da pesquisa',
        fieldPrompt: 'Prompt do campo',
        defaultPromptHint: 'Usa as instruções predefinidas configuradas para este campo.',
        usePrompt: 'Usar',
        recentPrompts: 'Recentes',
        allPrompts: 'Todos os prompts',
        browsePrompts: 'Explorar prompts',
        noPromptsFound: 'Nenhum prompt corresponde à sua pesquisa.',
        applyField: 'Aplicar ao campo',
        previewChanges: 'Visualizar alterações',
        originalResponse: 'Resposta original',
        inputPlaceholder: 'Peça à IA para reescrever a seleção...',
        sendHint: 'Dica: pressione Ctrl+Enter para enviar.',
        send: 'Enviar',
        stop: 'Parar geração',
        apply: 'Aplicar à seleção',
        you: 'Você',
        assistant: 'Assistente',
        updatedDraft: 'Aqui está uma versão atualizada do texto selecionado.',
        emptyDraft: 'A resposta da IA está vazia',
        requestFailed: 'Não foi possível gerar a resposta da IA',
        timedOut: 'A solicitação expirou. Isso pode acontecer em consultas complexas — seu prompt foi mantido, tente novamente.',
        noSelection: 'Selecione texto no campo antes de usar a IA.',
        generating: 'Gerando conteúdo...',
        leaveWhileGeneratingTitle: 'Geração por IA em andamento',
        leaveWhileGeneratingMessage: 'O conteúdo ainda está sendo gerado. Sair agora cancelará a solicitação de IA atual.',
        closeWhileGeneratingMessage: 'O conteúdo ainda está sendo gerado. Fechar o painel de IA mesmo assim?',
        discardAiSessionTitle: 'Descartar sessão de IA?',
        discardAiSessionMessage: 'O campo será desbloqueado e a conversa de IA atual será perdida.',
        discardAndStart: 'Descartar e iniciar nova',
        leaveWhileAiSessionMessage: 'Este campo está bloqueado por uma sessão de IA ativa. Sair agora irá descartá-la.',
        activeSession: 'Conclua ou feche a sessão de IA atual antes de iniciar outra.',
        applySelection: 'Aplicar seleção',
        insertAtCursor: 'Inserir no cursor',
        anchorCollapsed: 'O texto selecionado foi removido. O rascunho será inserido na posição original.',
        anchorLost: 'Não foi possível rastrear a seleção original. Selecione o texto novamente e tente de novo, ou copie a resposta manualmente.',
        tooltip: 'Assistente de IA'
    },
}
